import { useContext } from "react"
import { motion } from "motion/react"

import { AppContext } from "../App"

function GameOver() {
  const { gameOver, currAttempt, correctWord, onReset } = useContext(AppContext)

  const title = gameOver.guessedWord ? "Solved" : "Out of tries"
  const subtitle = gameOver.guessedWord
    ? `You solved it in ${currAttempt.attempt} attempts`
    : "Try again with the same settings"

  return (
    <motion.div
      className="game-over"
      initial={{ opacity: 0, y: 8, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.32 }}
    >
      <h3>{title}</h3>
      <p>{subtitle}</p>
      <p>
        Word: <strong>{correctWord}</strong>
      </p>
      <button type="button" className="settings-primary-button" onClick={onReset}>
        Reset board
      </button>
    </motion.div>
  )
}

export default GameOver
